import { render, staticRenderFns } from "./shipment-detail-from-problem-id.vue?vue&type=template&id=3e3b66d6&scoped=true"
import script from "./shipment-detail-from-problem-id.vue?vue&type=script&lang=js"
export * from "./shipment-detail-from-problem-id.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3b66d6",
  null
  
)

export default component.exports